import { Box, Typography, Paper, Grid, Container } from '@mui/material'
import { styled } from '@mui/material/styles'
import { colors } from 'theme'
import { NavLink } from 'react-router-dom'

export const IItems = styled(Typography)`
  display: flex;
  align-items: center;
  height: 24px;
  justify-content: space-between;
`

export const NftContentBox = styled(Grid)``

export const FlexBox = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const FlexCenterBox = styled(Box)`
  display: flex;
  align-items: center;
`

export const LoginBox = styled(Box)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 560px;
  box-shadow: -10px 0px 40px rgba(0, 0, 0, 0.4);
  background: ${props => props.theme.colors.background.article};
  color: ${props => props.theme.colors.white};
  padding: 40px 56px;
  :focus-visible {
    outline: none;
  }
  .MuiInputBase-root:hover {
    border-color: #ffffff !important;
  }
  .MuiButton-outlinedPrimary {
    height: 68px;
    @media (max-width: 900px) {
      height: 58px;
    }
  }
  .MuiButton-containedPrimary {
    height: 68px;
    font-weight: 700;
    font-family: 'Roboto Condensed', sans-serif;
    font-size: 20px;
    line-height: 20px;
    @media (max-width: 900px) {
      height: 58px;
      font-size: 18px;
      line-height: 26px;
    }
  }
  .MuiInputBase-root {
    display: block;
    margin-bottom: 1rem;
    width: 100%;
    padding: 0 24px;
    font-weight: 400;
    font-size: 18px;
    height: 66px;
    overflow: hidden;
    color: ${colors.white};
    border-radius: 0;
    border: 2px solid #565656;
    .MuiInputAdornment-positionEnd {
      position: absolute;
      right: 24px;
      top: 32px;
      .MuiTypography-root {
        font-weight: 600;
        font-size: 1.125rem;
        line-height: 1.25rem;
        color: ${colors.white};
        opacity: 0.8;
        cursor: pointer;
      }
    }
    input {
      padding: 0;
      height: 62px;
      box-shadow: 0 0 0px 1000px #121212 inset;
      -webkit-text-fill-color: white !important;
    }
    @media (max-width: 900px) {
      height: 56px;
      input {
        height: 52px;
      }
      .MuiInputAdornment-positionEnd {
        top: 25px;
      }
    }
  }
  .MuiTypography-h1 {
    color: ${colors.white};
    font-weight: 700;
    font-family: 'Roboto Condensed', sans-serif;
    font-size: 40px;
    line-height: 48px;
    margin: 24px 0;
  }
  .close {
    position: absolute;
    top: 28px;
    right: 32px;
    cursor: pointer;
  }
`
export const InsertPaper = styled(Paper)`
  padding: 2px 20px;
  display: flex;
  align-items: center;
  border-radius: 6px;
  height: 52px;
  margin: 0 0 17px 0;
  box-shadow: none;
  border-bottom-width: 0;
  background-color: rgba(80, 80, 160, 0.1);
  .input-ph-r {
    input::placeholder {
      font-size: 20px;
      text-align: right;
      color: rgba(3, 1, 27, 0.2);
    }
  }
`
export const SectionTitle = styled(Typography)`
  font-weight: 700;
  font-family: 'Roboto Condensed', sans-serif;
  font-size: 40px;
  line-height: 48px;
  margin-bottom: 60px;
  text-align: center;
`

export const GameCard = styled(NavLink)`
  > img {
    border-radius: 8px 8px 0 0;
  }
  > div {
    border-radius: 0 0 8px 8px;
    padding: 32px 48px 32px;
    margin-top: -6px;
    /* height: 207px; */
    white-space: break-spaces;
    overflow: auto;
    p {
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
    }
    h4 {
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
  }
  &:hover {
    h4 {
      color: ${props => props.theme.colors.primary[600]};
    }
  }
`
export const EditWrapper = styled(Container)`
  width: 100%;
  max-width: 100% !important;
  position: absolute;
  top: 0;
  z-index: 999;
  background: ${props => props.theme.colors.background.article};
  min-height: calc(100vh - 56px);
  @media (min-width: 600px) {
    padding: 0;
  }
`

export const EditHead = styled(Box)`
  display: flex;
  height: 56px;
  align-items: center;
  background: #161616;
  margin-bottom: 16px;
  padding: 0 40px;
  position: fixed;
  width: 100%;
  z-index: 999;
  /* justify-content: space-between; */
  svg {
    cursor: pointer;
  }
`

export const Tags = styled('span')`
  padding: 6px 8px;
  font-size: 14px;
  line-height: 22px;
  color: #a2a2a2;
  background-color: #323232;
  margin-right: 8px;
  display: flex;
  align-items: center;
`

export const ViewDetails = styled('span')`
  font-weight: 500;
  text-decoration: underline;
  cursor: pointer;
`
